import { render } from "./AccountCancel.vue?vue&type=template&id=645a893d&scoped=true"
import script from "./AccountCancel.vue?vue&type=script&lang=js"
export * from "./AccountCancel.vue?vue&type=script&lang=js"

import "./AccountCancel.vue?vue&type=style&index=0&id=645a893d&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645a893d"]])

export default __exports__